import axios from 'axios';

const API_BASE_URL = 'https://vitaldev.vitalinsights.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

// Update token in headers when it changes
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const tacticsService = {
  // Get all tactics
  getAllTactics: async () => {
    try {
      const response = await api.get('/admin/tactics');
      return response.data;
    } catch (error) {
      console.error('Error fetching tactics:', error);
      throw error;
    }
  },

  // Get a single tactic by ID
  getTacticById: async (tacticId) => {
    try {
      const response = await api.get(`/admin/tactics/${tacticId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching tactic:', error);
      throw error;
    }
  },

  // Create a new tactic
  createTactic: async (tacticData) => {
    try {
      return await api.post('/admin/tactics', { data: tacticData });
    } catch (error) {
      console.error('Error creating tactic:', error);
      throw error;
    }
  },

  // Update an existing tactic
  updateTactic: async (tacticId, tacticData) => {
    try {
      return await api.put(`/admin/tactics/${tacticId}`, { data: tacticData });
    } catch (error) {
      console.error('Error updating tactic:', error);
      throw error;
    }
  },

  // Delete a tactic
  deleteTactic: async (tacticId) => {
    try {
      return await api.delete(`/admin/tactics/${tacticId}`);
    } catch (error) {
      console.error('Error deleting tactic:', error);
      throw error;
    }
  },
};
